const setBackgroundColor = (color) => {
  if (color === '#FF6666') return '#FF66661A';
  if (color === '#219E66') return '#ECFBF4';
  if (color === '#FF7600') return '#FFF4EB';

  return '#E5F7FF';
};

export default setBackgroundColor;
